module.exports = __webpack_public_path__ + "img/CQRM.3209ae92.jpg";